import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { NoteService } from 'src/app/services/note.service';
import { NoteDTO } from 'src/app/interfaces/note';
import { UserDTO } from 'src/app/interfaces/user';
import { CommonModule, DatePipe } from '@angular/common';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-revisions',
    imports: [DatePipe, MatListOption, MatSelectionList, FormsModule, CommonModule],
    templateUrl: './revisions.component.html',
    styleUrls: ['./revisions.component.scss'],
})
export class RevisionsComponent implements OnInit {

  note: NoteDTO;
  isLoggedIn: boolean;
  user: UserDTO;
  role: string;
  isOk: boolean;
  title: string;
  editorData: string;
  revisions: NoteDTO[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private errorhandling: ErrorhandlingService, private noteService: NoteService, private router: Router, private tokenStorageService: TokenStorageService, public dialogRef: MatDialogRef<RevisionsComponent>, @Inject(MAT_DIALOG_DATA) data) { 
    this.note = data;
    this.title = this.note.title;
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } else {
      this.isOk = false;
    } 
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
    this.getRevisions();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Unsubscribe from the subject
    this.destroy$.unsubscribe();
  }

  async getRevisions() {
    if (this.note != null) {
      this.revisions = await firstValueFrom(this.noteService.getRevisions(this.note.calendarId, this.note.uuid));
    }
    }

  showRevision(revision : NoteDTO) {
    this.editorData = revision.stringText;
  }

  close() {
    this.dialogRef.close();
  }

}
